import React from 'react'
import { Section, MainTitle, Paragraf } from '../Styled'
import { FeaturesInner, FeaturesLeft, FeaturesRight } from './Feature.styled'
import IconCard from './IconCard'

const Features = ({ CARDS, title, body }) => {
    return (
        <Section>
            <FeaturesInner>
                <FeaturesLeft>

                    {
                        CARDS.map((kort) => {
                            return (
                                <IconCard
                                    key={kort.id}
                                    title={kort.title}
                                    text={kort.text}
                                    className={kort.className}
                                    id={kort.id}
                                    source={kort.source}
                                />
                            )
                        })
                    }
                </FeaturesLeft>
                <FeaturesRight>
                    <MainTitle>
                        {title}
                    </MainTitle>
                    <Paragraf>
                        {body}
                    </Paragraf>
                </FeaturesRight>
            </FeaturesInner>
        </Section>
    )
}

export default Features